import React, { useState, useCallback } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import API from "../../Network/API";



export default function ShareMeeting(props) {
    const [data, setData] = useState(null);
  const [name, setName] = useState(null);
  const [isLoading, setLoad] = useState(false);
  const [user_select_data, setUserSelectData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [user_id, setUserId] = useState([]);
  const [meeting_link, setMeetingLink] = useState(null);
  const domainName = 'https://connectsapp.com';
    
    const myArr = JSON.parse(localStorage.getItem('user_data'));
    function myFunction() {
        var copyText = document.getElementsByClassName("myInput");
        navigator.clipboard.writeText(copyText[0].textContent+'\n\n'+copyText[1].textContent+'\n'+copyText[2].textContent+'\n'+copyText[3].textContent+'\n\n'+copyText[4].textContent+'\n'+copyText[5].textContent+'\n'+copyText[6].textContent);
      }

      const clear_search=()=>{
        setLoad(false)
      }
    
      function search_friend(e) {
        setName(e)
        if (e !== "" || e !== null) {
          setLoad(true)
          API.get(`/v3/search_friend?q=${e}`).then((response) => {
            setLoad(true)
            const result = response.data.data;
            // Prevent self-invite: remove the current user from results
            if (result?.users) {
              result.users = result.users.filter(
                (u) => String(u.user_id) !== String(myArr?.id)
              );
            }
            setData(result)
          }).catch((error) => {
            setLoad(false)
          });
        }
    
      }
    
      const AddUserId = (event) => {
        if (event.target.checked) {
          if (user_id.indexOf(parseInt(event.target.value)) === -1) {
            user_id.push(parseInt(event.target.value))
            user_select_data.push({
              'id':parseInt(event.target.value),
              'name':event.target.title,
            })
          }
        } else {
         removeID(parseInt(event.target.value))
        }
        setLoad(false)
      }
    
    const removeUser=(sl,u_id)=>{
       setUserSelectData(user_select_data.filter(a =>
           a.id !== u_id
       ))
       removeID(u_id)
    }

    const AddGroupId = (event) => {
      if (event.target.checked) {
        if (user_id.indexOf(event.target.value) === -1) {
          user_id.push(event.target.value)
          user_select_data.push({
            'id': event.target.value,
            'name': event.target.title,
          })
        }
      } else {
        removeID(event.target.value)
      }
      setLoad(false)
    }
    
      const removeID = (url) => {
        const index = user_id.indexOf(url);
        if (index > -1) {
          user_id.splice(index, 1);
    
        }
        setUserId(user_id)
    
      }
    
      
      const checkedState=(id)=>{
        return user_id.find((element) => {
          return element === id;
        })
      }

      const _schdeule_done=()=>{
        window.location.href = "/meeting";
    }

      const handleSubmit = event => {
        event.preventDefault();
        setLoading(true);
        var copyText = document.getElementsByClassName("myInput");
        var data = {
          'user_id': user_id,
          'room_id': props.meetingRoom?.room_name,
          'message': copyText[0].textContent+'\n\n'+copyText[1].textContent+'\n'+copyText[2].textContent+'\n'+copyText[3].textContent+'\n\n'+copyText[4].textContent+'\n'+copyText[5].textContent+'\n'+copyText[6].textContent,
          'message_type': 10,
        }
        API.post('/v3/meeting_share', data).then(response => {
          setLoading(false);
          if (response.data.success === true) {
              toast.success('Meeting shared');
              props.handleShowB()
          }
        }).catch((error) => {
          setLoading(false);
          console.log(error.message)
          toast.error('Please try again.');
        });
      }

      const _start_meeting=(meeting_id)=>{
        if(meeting_id){
          window.location.href = "/meeting/"+meeting_id;
        }else{
          toast.error("Please enter meeting id");
        }
      }

    return (
    <>
        <Modal
            isOpen={props.isModalVisible}
            size=""
            scrollable={false}
            toggle={props.handleShowB}
            className={'modal-dialog'} backdrop="static"
        >
          <ModalHeader className="border-0 pb-2" toggle={props.handleShowB} id={'staticBackdropLabel'}>
            <h5 className="modal-title fw-bold text-dark mb-0">Invite new user</h5>
          </ModalHeader>
          
            <ModalBody className="bg-white px-4 py-0" style={{overflow: 'visible'}}>
              <div className="meeting-schedule-popup">
              <form onSubmit={handleSubmit}>
              <div className="py-3">

                <div className="mb-3">
                  <label className="form-label fw-medium text-dark mb-2" style={{fontSize: '13px'}}>
                    Meeting Invitation
                  </label>
                  <div className="bg-light border rounded-2 p-3" style={{fontSize: '14px', lineHeight: '1.5'}}>
                    <div className="text-dark myInput mb-2">
                      <strong>{myArr?.name}</strong> is inviting you to a scheduled connects meeting.
                    </div>
                    <div className="mt-3 mb-3">
                      <div className="text-dark myInput mb-1"><strong>Topic:</strong> {props.meetingRoom?.room_title}</div>
                      <div className="text-dark myInput mb-1"><strong>Time:</strong> {new Date(props.meetingRoom?.start_date).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</div>
                      <div className="text-dark myInput mb-1"><strong>Timezone:</strong> {props.meetingRoom?.time_zone}</div>
                    </div>
                    <div className="mt-3">
                      <div className="text-dark myInput mb-1"><strong>Join Connect Meeting</strong></div>
                      <div className="text-dark myInput mb-1" style={{fontFamily: 'monospace'}}>
                        {domainName}/meeting/{props.meetingRoom?.room_name}
                      </div>
                      <div className="text-dark myInput"><strong>Meeting ID:</strong> {props.meetingRoom?.room_name}</div>
                    </div>
                  </div>
                </div>

                <div className="mb-3 d-flex justify-content-end">
                  <button 
                    type="button" 
                    className="btn btn-outline-dark btn-sm rounded-2"
                    onClick={myFunction}
                    style={{fontSize: '12px', fontWeight: '500'}}
                  >
                    <i className="fa-solid fa-copy me-2" style={{fontSize: '11px'}}></i>
                    Copy Meeting Invitation
                  </button>
                </div>


                <div className="mb-3">
                  <label className="form-label fw-medium text-dark mb-2" style={{fontSize: '13px'}}>
                    Invite Contact
                  </label>
                  <div className="position-relative">
                    <input 
                      onChange={(e) => search_friend(e.target.value)} 
                      className="form-control py-2 px-3 rounded-2" 
                      placeholder="Search Contact"
                      style={{fontSize: '14px', borderColor: '#e9ecef'}}
                    />
                    <i className="fa-solid fa-search position-absolute top-50 end-0 translate-middle-y me-3 text-muted" style={{fontSize: '12px'}}></i>

                    {name !== '' && isLoading && (
                      <div 
                        className="position-absolute w-100 mt-1 bg-white border rounded-2 shadow-sm" 
                        style={{
                          zIndex: 1050,
                          maxHeight: '300px', 
                          overflowY: 'auto',
                          minHeight: 'auto'
                        }}
                      >
                        <div className="p-2">
                          {data?.users?.length > 0 && (
                            <>
                              <div className="text-muted small mb-2 px-2 py-1" style={{fontSize: '11px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px'}}>
                                <i className="fa-solid fa-user me-1"></i>Contacts ({data.users.length})
                              </div>
                              {data.users.map((value, index) => (
                                <div 
                                  key={`user-${value.user_id}-${index}`} 
                                  className="d-flex align-items-center p-2 rounded-2 hover-bg-light cursor-pointer border-bottom border-light"
                                  style={{minHeight: '60px'}}
                                >
                                  <div className="me-2">
                                    <div 
                                      className="rounded-circle bg-light"
                                      style={{ 
                                        width: '32px', 
                                        height: '32px', 
                                        backgroundImage: `url("${value.avatar}")`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        flexShrink: 0
                                      }} 
                                    />
                                  </div>
                                  <div className="flex-grow-1 min-w-0 me-2">
                                    <div className="text-dark fw-medium" style={{fontSize: '13px'}}>
                                      {value.name}
                                    </div>
                                    <div className="text-muted small" style={{fontSize: '11px'}}>
                                      {value.email || 'Hey there! I am using connects'}
                                    </div>
                                  </div>
                                  <div style={{flexShrink: 0}}>
                                    <input 
                                      name={`user[${value.user_id}]`} 
                                      className="form-check-input"
                                      title={value.name} 
                                      value={value.user_id} 
                                      type="checkbox"
                                      onClick={(e) => AddUserId(e)}
                                      id={`user-checkbox-${value.user_id}-${index}`}
                                      style={{transform: 'scale(1.1)'}}
                                      checked={checkedState(parseInt(value.user_id))}
                                    />
                                  </div>
                                </div>
                              ))}
                            </>
                          )}

                          {data?.groups?.length > 0 && (
                            <>
                              <div className="text-muted small mb-2 px-2 py-1 mt-2" style={{fontSize: '11px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px'}}>
                                <i className="fa-solid fa-users me-1"></i>Groups ({data.groups.length})
                              </div>
                              {data.groups.map((value, index) => (
                                <div 
                                  key={`group-${value.id}-${index}`} 
                                  className="d-flex align-items-center p-2 rounded-2 hover-bg-light cursor-pointer border-bottom border-light"
                                  style={{minHeight: '60px'}}
                                >
                                  <div className="me-2">
                                    <div 
                                      className="rounded-circle bg-light"
                                      style={{ 
                                        width: '32px', 
                                        height: '32px', 
                                        backgroundImage: `url("${value.avatar}")`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        flexShrink: 0
                                      }} 
                                    />
                                  </div>
                                  <div className="flex-grow-1 min-w-0 me-2">
                                    <div className="text-dark fw-medium" style={{fontSize: '13px'}}>
                                      {value.name}
                                    </div>
                                    <div className="text-muted small" style={{fontSize: '11px'}}>
                                      Group chat
                                    </div>
                                  </div>
                                  <div style={{flexShrink: 0}}>
                                    <input 
                                      name={`group[${value.id}]`} 
                                      className="form-check-input"
                                      title={value.name} 
                                      value={value.id} 
                                      type="checkbox"
                                      onClick={(e) => AddGroupId(e)}
                                      id={`group-checkbox-${value.id}-${index}`}
                                      style={{transform: 'scale(1.1)'}}
                                      checked={checkedState(value.id)}
                                    />
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                          
                          {(!data?.users?.length && !data?.groups?.length) && (
                            <div className="text-center py-3">
                              <i className="fa-solid fa-user-slash text-muted mb-2" style={{fontSize: '20px'}}></i>
                              <div className="text-muted" style={{fontSize: '12px'}}>No contacts found</div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {user_select_data?.length > 0 && (
                  <div className="mb-3">
                    <div className="d-flex flex-wrap gap-2">
                      {user_select_data.map((username, i) => (
                        <span 
                          key={i} 
                          className="badge bg-light text-dark rounded-pill px-3 py-2 d-flex align-items-center"
                          style={{fontSize: '12px'}}
                        >
                          <i className="fa-solid fa-user me-2" style={{fontSize: '10px'}}></i>
                          {username.name}
                          <button
                            type="button"
                            className="btn btn-sm ms-2 p-0 border-0 bg-transparent"
                            onClick={() => removeUser(i, username.id)}
                            style={{fontSize: '10px', width: '16px', height: '16px'}}
                          >
                            <i className="fa-solid fa-times text-muted"></i>
                          </button>
                        </span>
                      ))}
                    </div>
                  </div>
                )}

              </div>
              <ModalFooter className="border-0 pt-2 px-4 pb-3">
                <div className="d-flex justify-content-end gap-2 w-100">
                  <button 
                    type="button" 
                    onClick={props.handleShowB}
                    className="btn btn-light rounded-pill px-4 py-2"
                    style={{fontSize: '13px', fontWeight: '500'}}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-dark rounded-pill px-4 py-2"
                    style={{fontSize: '13px', fontWeight: '500'}}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                          style={{width: '14px', height: '14px'}}
                        ></span>
                        Inviting...
                      </>
                    ) : (
                      <>
                        <i className="fa-solid fa-paper-plane me-2" style={{fontSize: '12px'}}></i>
                        Invite
                      </>
                    )}
                  </button>
                </div>
              </ModalFooter>
            </form>
          </div>
          </ModalBody>
          
        </Modal>
    </>)
}